/**
 * Política de contraseña nueva (cambio de contraseña / registro coherente).
 * Símbolos permitidos evitan comillas y ; típicos en inyección SQL.
 */

/** Al menos uno de estos cuenta como “símbolo” permitido. */
export const PASSWORD_ALLOWED_SPECIAL_RE = /[@#\-_$!%*?&+=.,:]/;

/** Caracteres o secuencias no permitidas. */
export const PASSWORD_FORBIDDEN_RE = /['"`;\\]|[\u0000-\u001F]|--|\/\*|\*\//;

/**
 * @param {string} [password]
 * @returns {{ minLength: boolean, hasUpper: boolean, hasLower: boolean, hasSpecial: boolean }}
 */
export function analyzeNewPassword(password) {
  const p = String(password ?? '');
  return {
    minLength: p.length >= 8,
    hasUpper: /\p{Lu}/u.test(p),
    hasLower: /\p{Ll}/u.test(p),
    hasSpecial: PASSWORD_ALLOWED_SPECIAL_RE.test(p),
  };
}

export function newPasswordMatchesConfirm(password, confirm) {
  const p = String(password ?? '');
  const c = String(confirm ?? '');
  return p.length > 0 && p === c;
}

/**
 * @returns {string|null} mensaje de error o null si cumple política y coincide con confirmación
 */
export function validateNewPasswordForSubmit(password, confirm) {
  const p = String(password ?? '');
  const c = String(confirm ?? '');
  if (PASSWORD_FORBIDDEN_RE.test(p)) {
    return 'La contraseña incluye caracteres o combinaciones no permitidas.';
  }
  if (p.length < 8) {
    return 'La contraseña nueva debe tener al menos 8 caracteres.';
  }
  if (!/\p{Lu}/u.test(p)) {
    return 'La contraseña nueva debe incluir al menos una letra mayúscula.';
  }
  if (!/\p{Ll}/u.test(p)) {
    return 'La contraseña nueva debe incluir al menos una letra minúscula.';
  }
  if (!PASSWORD_ALLOWED_SPECIAL_RE.test(p)) {
    return 'La contraseña nueva debe incluir al menos un símbolo permitido: @ # - _ $ ! % * ? & + = . , :';
  }
  if (p !== c) {
    return 'La contraseña nueva y la repetición no coinciden.';
  }
  return null;
}
